export function navigateToLocalErrorPage() {
    window.location.href = "/error";
}
